import { Injectable } from '@angular/core';
import { BrowserMultiFormatReader, IScannerControls } from '@zxing/browser';

@Injectable({
  providedIn: 'root'
})
export class BarcodeScannerService {
  private codeReader = new BrowserMultiFormatReader();
  private controls: IScannerControls | null = null;

  async scanBarcode(videoElement: HTMLVideoElement): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        const mediaDevices=navigator.mediaDevices;
        // if (mediaDevices==null) {
        //   reject('No_camera_found');
        //   return;
        // }
        // const devices = await navigator.mediaDevices.enumerateDevices();
        // if(devices==null){
        //   reject('No_camera_found');
        //   return;
        // }
        // const videoDevices = devices.filter(device => device.kind === 'videoinput');
        // if(videoDevices==null){
        //   reject('No_camera_found');
        //   return;
        // }
        // if (videoDevices.length === 0) {
        //   reject('No_camera_found');
        //   return;
        // }

        this.codeReader.decodeFromVideoDevice(undefined, videoElement, (result, error) => {
          if (result) {
            this.stopScanner();
            resolve(result.getText());
          } else if (error) {
            console.warn('Scan_Error', error);
          }
        }).then(controls => {
          this.controls = controls;
        }).catch(err => {
          if (err.message=='Permission denied') {
            reject('permission_denied_camera');
          }else{
            reject('Error_accessing_camera' + err);
          }
        });

      } catch (error) {
        reject('Error_accessing_camera' + error);
      }
    });
  }

  stopScanner() {
    if (this.controls) {
      this.controls.stop();
      this.controls = null;
    }
  }
}
